import clsx from 'clsx';
import React from 'react';

import { PrimaryButton, ProButton } from '@components/Button/variants';
import useEventTracking from '@hooks/useEventTracking';
import { subscribe_one_path, subscribe_path } from '@routes';
import { ClickTarget, click } from '@tracking';

import { backgroundColorValues, marginValues, paddingValues } from './constants';
import type { SubscribeButtonBlockProps } from './interfaces';

const SubscribeButtonBlock = ({ config, offer }: SubscribeButtonBlockProps) => {
  const { trackEvent } = useEventTracking({
    location: config?.analytics_location,
  });

  const Button = offer?.isPro || config.pro_subscription ? ProButton : PrimaryButton;

  const handleClick = () => {
    trackEvent(
      click({
        clickTarget: ClickTarget.Subscribe,
        clickText: config?.text,
      })
    );
  };

  return (
    <article className="subscribe-button-block">
      <Button
        as="link"
        className={clsx(
          'subscribe-button-block',
          config?.css_classes,
          backgroundColorValues[config?.background_color],
          marginValues[config?.margin],
          paddingValues[config?.padding]
        )}
        href={
          config.subscribe_one
            ? subscribe_one_path({ offer: offer?.code })
            : subscribe_path({ offer: offer?.code })
        }
        onClickCapture={handleClick}
      >
        {config?.text}
      </Button>
    </article>
  );
};

export default SubscribeButtonBlock;
